import { useQuery, useQueryClient } from 'react-query';
import { ITableHeaders } from 'shared/components/Table/Table';
import { reportService } from 'shared/services/ReportsService';

interface IUseStandardReport {
    year: number;
    organization: number;
    facility: number;
    code: number;
    headers: ITableHeaders[];
}

export const useStandardReportMonthly = (params: IUseStandardReport) => {
    const queryClient = useQueryClient();

    const { data, isLoading, isError, refetch } = useQuery(
        [
            'standard-report-month',
            params.code,
            params.facility,
            params.organization,
            params.year,
            `${params.headers.filter((header) => header.selected)[0]?.title}=${
                params.headers.filter((header) => header.selected)[0]?.sortable
            }`,
        ],
        () => {
            const queryParams: any = {};

            if (params?.year) {
                queryParams['year'] = params.year;
            }
            if (params?.organization) {
                queryParams['organization.id'] = params.organization;
            }
            if (params?.facility) {
                queryParams['facility.id'] = params.facility;
            }
            if (params?.code) {
                queryParams['condition.id'] = params.code;
            }

            return reportService.getStandardReportMonthly(queryParams);
        },
        {
            onError: (error: Error) => {
                console.log('Error on getting student - ', error);
            },
            initialData: () =>
                queryClient.getQueryData([
                    'standard-report',
                    params.code,
                    params.facility,
                    params.organization,
                    params.year,
                    `${
                        params.headers.filter((header) => header.selected)[0]
                            ?.title
                    }=${
                        params.headers.filter((header) => header.selected)[0]
                            ?.sortable
                    }`,
                ]),
            // staleTime: TimeDurationEnum.HOUR,
            // cacheTime: 0,
        }
    );

    return {
        data,
        isLoading,
        serverErrorMessage: isError,
        refetch,
    };
};
